export default __webpack_public_path__ + "static/media/info.f36e690c.svg";